import React from 'react'
import craftPreditionImg from 'assets/img/my-hub/craft-prediction-placeholder.png'
import craftPreditionIcon from 'assets/img/icons/craft-prediction.svg'
import craftIdentityImg from 'assets/img/my-hub/craft-identity-placeholder.png'
import craftIdentityIcon from 'assets/img/icons/craft-identity.svg'
import { Link } from 'react-router-dom'

const PlaceholderCraftBlock = ({ type }) => {

  const getData = () => {
    if (type === 'prediction') {
      return {
        modificatorClass: 'predictions',
        img: craftPreditionImg,
        icon: craftPreditionIcon,
        title: 'My Predictions',
        text: 'Craft Prediction',
        url: '/crafting/prediction'
      };
    }

    if (type === 'identity') {
      return {
        modificatorClass: 'identities',
        img: craftIdentityImg,
        icon: craftIdentityIcon,
        title: 'My Identities',
        text: 'Craft an Identity',
        url: '/crafting/identity'
      }
    }
  }

  return (
    <section className={`craft-placeholder craft-placeholder--${getData().modificatorClass}`}>
      <img src={getData().img} className='craft-placeholder__img' alt="" />
      <h5 className="craft-placeholder__title">{getData().title}</h5>
      <Link className="craft-placeholder__button" to={getData().url}>
        <img src={getData().icon} alt="" /> {getData().text}
      </Link>
    </section>
  )
}

export default PlaceholderCraftBlock;
